import { Signal } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';
import { OrgThemeColors } from '@core/tellent-types';

export const { provide: provideAppShellThemeColors, inject: injectAppShellThemeColors } =
  createProviderToken<Signal<OrgThemeColors>>('AppShellTheme')();
